import Main from '../views/appointment/pages/Main';
import History from '../views/appointment/pages/History';
import MyRecords from '../views/appointment/pages/MyRecords';

export default [
  {
    path: '',
    name: 'appointment.make',
    component: Main
  },
  {
    path: 'history',
    name: 'appointment.history',
    component: History
  },
  {
    path: 'myrecords',
    name: 'appointment.myrecords',
    component: MyRecords
  }
];
